import React from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { arrayOf, shape, string, bool, number, oneOfType } from 'prop-types'

import { EMPTY_ARRAY, EMPTY_OBJECT } from 'Utils/stableDefaults'

import GenerationResult from './Components/GenerationResult/GenerationResult'
import Section from './Components/Section/Section'

// "Create with AI" dropdown panel: Tools / Community link sections anchored to the
// Create with AI trigger. Reuses the shared `.unified-nav__dropdown` card so it matches
// the Sellers Hub panel and renders in-flow inside the stacked mobile hamburger, where
// the free-trial banner is hidden (the trigger carries a tag instead). The banner is
// hidden for viewers who cannot get a trial (`showFreeTrialTag` from the backend). Every finished
// 3D-model generation the user has not opened yet stacks a result row below the links
// (paid tiers can run several generations concurrently).
function CreateAiDropdown({
  id = undefined,
  freeTrial = '',
  sections = EMPTY_ARRAY,
  showFreeTrialTag = false,
  isSignedIn = false,
  lastResults = EMPTY_ARRAY,
  labels = EMPTY_OBJECT,
}) {
  const showBanner = Boolean(showFreeTrialTag && freeTrial)

  return (
    <div
      className={classnames(
        'unified-nav__dropdown',
        'unified-nav__dropdown--create-ai',
        showBanner && 'unified-nav__dropdown--with-banner'
      )}
      id={id}
    >
      {showBanner && (
        <p className="unified-nav__dropdown-banner">
          <span className="unified-nav__dropdown-tag-text">{freeTrial}</span>
        </p>
      )}
      {sections.map((section) => (
        <Section key={section.id} title={section.title} links={section.links} isSignedIn={isSignedIn} />
      ))}
      {lastResults.length > 0 && (
        <div className="unified-nav__dropdown-result-section">
          {lastResults.map((result) => (
            <GenerationResult
              key={result.runId ?? result.pathname}
              result={result}
              labels={labels}
            />
          ))}
        </div>
      )}
    </div>
  )
}

CreateAiDropdown.propTypes = {
  id: string,
  freeTrial: string,
  showFreeTrialTag: bool,
  isSignedIn: bool,
  sections: arrayOf(shape({
    id: string,
    title: string,
    links: arrayOf(shape({
      id: string,
      href: string,
      landingHref: string,
      title: string,
      trackText: string,
      icon: string,
    })),
  })),
  lastResults: arrayOf(shape({
    runId: oneOfType([number, string]),
    status: string,
    pathname: string,
    previewUrl: string,
  })),
  labels: shape({
    readyTitle: string,
    errorTitle: string,
    errorHref: string,
  }),
}

export default CreateAiDropdown
